import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import {ANIMATION} from "../../../../constants/fields.constants";
import {DataService} from "../../../../../services/data.service";
import {ActionButton, SearchState} from "../../../../../common/interfaces/data.interfaces";


@Component({
  selector: 'search-fields',
  templateUrl: './search-fields.component.html',
  styleUrls: ['./search-fields.component.scss']
})
export class SearchFieldsComponent implements OnInit,OnChanges {
  @Input() animation = ANIMATION;
  @Input() searchKeys = [];
  @Input() searchByMultipleKeys = false;
  @Input() order = 2;

  @Input() searchInputStates:SearchState[] = [];
  @Output() searchInputChange = new EventEmitter<SearchState[]>();

  timer = undefined;
  unUsedKeys = [];

  addbutton:ActionButton = {
    type:'mini-icon',
    class:'border',
    icon:'add',
    callBack:() => this.addState()
  };


  constructor(private ds:DataService){ }

  setData(){
    if(!this.searchInputStates.length) this.searchInputStates = [{key:this.searchKeys[0]}];
    const used = this.searchInputStates.filter(s => this.ds.isValue(s.value)).map(s => s.key);
    this.unUsedKeys = this.searchKeys.filter(k => !this.ds.valueIsEither(k,used));
  }

  ngOnChanges(changes: SimpleChanges): void {
   this.setData();
  }

  ngOnInit(): void {
    this.setData();
  }

  onKeyUp(state:SearchState){
    if(this.timer) clearTimeout(this.timer);
    this.timer = setTimeout(async () => {
      this.searchInputChange.emit(this.searchInputStates);
    }, state.value?.trim() ?  2000 : 0 ); //search rightaway if no value (to populate the first n items)
  }

  onSelectionChange(state:SearchState){
    if(!this.ds.isValue(state.value)) return;
    this.searchInputChange.emit(this.searchInputStates);
  }

  removeState(state:SearchState){
    if(!this.ds.isValue(state.value)) return;
    this.searchInputChange.emit(this.searchInputStates);
  }

  addState(){
    const unUsedKey = this.getUnusedKey();
    this.searchInputStates.push({key:unUsedKey, value:''});
  }

  getUnfilledState(){
    return this.searchInputStates.find(s => !this.ds.isValue(s.value));
  }

  getUnusedKey(){
    return this.searchKeys.find(k =>!this.ds.valueIsEither(k,this.searchInputStates.map(s => s.key)));
  }

}


